import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadProductTypes = createAction('[ProductTypes] Load ProductTypes');

export const loadProductTypesSuccess = createAction(
  '[ProductTypes] Load ProductTypes Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductTypesFailure = createAction('[ProductTypes] Load ProductTypes Failure', props<{ error: any }>());
